import { post } from "app/utils/axios/kheti";
import { CreateDiagnosisResponse } from "../models/diagnosis";

const createDiagnosis = async (formData: FormData) => {
  try {
    const response = await post<CreateDiagnosisResponse>(
      "/plantix/v2/new",
      formData
    );
    return response.plantix_id;
  } catch (e) {
    return null;
  }
};

export default createDiagnosis;
